export default "__VITE_ASSET__C$qx4OU3__"